import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'isMismachimDocType',
})
export class IsMismachimDocTypePipe implements PipeTransform {
	transform(value: string | number | null): boolean {
		if (value === null) return false;
		if (typeof value === 'number') value = value.toString();

		return ['1', '2', '3', '4', '5', '37'].includes(value);
	}
}
